import React from "react";
import { useEffect,useState } from "react";
import Chart from "react-apexcharts";
import { toast } from "react-toastify";
import { getTimeChartDashboardApi, getUserTimeChartDashboardApi } from "../../../services/DashboardService";

const UserTimeChart = () => {
  const [data, setData] = useState([]);
  const getTimeData = () => {
    getUserTimeChartDashboardApi()
      .then((res) => {
        const timeData = res.data.results?.map((item) => ({
          time_interval: item?.time_interval || "",
          billings_count: item?.billings_count || "",
        }));
        setData(timeData);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      });
  };
  useEffect(() => {
    getTimeData();
  }, []);
  const series = [
    {
      name: "Billing Count",
      data: data?.map((item) => Number(item?.billings_count)) || [],
    },
  ];
  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        columnWidth: "50%",
        distributed: true,
      },
    },
    colors: ["#7f0000", "#b71c1c", "#c62828", "#d32f2f", "#e53935", "#f44336"],
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: {
      categories:
        data?.map((item) =>
          item?.time_interval?.length > 4
            ? item.time_interval.slice(0, 4) + "..."
            : item.time_interval
        ) || [],
      labels: {
        style: {
          fontSize: "13px",
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    tooltip: {
      enabled: true,
      shared: false,
      intersect: true,
      custom: function ({ dataPointIndex }) {
        const fullLabel = data?.[dataPointIndex]?.time_interval || "";
        const billingCount = data?.[dataPointIndex]?.billings_count || 0;

        return `
      <div style="
        background: #fff;
        color: #333;
        padding: 8px 12px;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0,0,0,0.15);
        font-size: 13px;
        line-height: 1.5;
        min-width: 140px;
      ">
        <div style="font-weight:600; font-size:14px; margin-bottom:4px; color:#2a3f54;">
          ${fullLabel}
        </div>
        <div style="font-size:13px; color:#555;">
          Billing Count: <span style="font-weight:600; color:#111;">${billingCount}</span>
        </div>
      </div>
    `;
      },
    },
  };

  return (
    <div className="card p-2 pb-0 border-0 shadow-sm rounded-3 h-100">
      <div className="mb-2 px-1">
        <h5>Billing</h5>
      </div>
      <div>
        <Chart options={options} series={series} type="bar" height={280} />
      </div>
    </div>
  );
};

export default UserTimeChart;
